import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function DeleteGateentries() {
  const [search, setSearch] = useState("");

  const [gateEntries, setGateEntries] = useState([]);
  const token = sessionStorage.getItem("token");

  /* =========================
     FETCH ALL DATA
  ========================= */
  const fetchGateEntries = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/delete/gate-entries",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setGateEntries(res.data.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch data", "error");
    }
  };

  useEffect(() => {
    fetchGateEntries();
  }, []);

  /* =========================
     DELETE FUNCTION
  ========================= */
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete Gate Entry?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, Delete",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(
        `https://irc.zentelex.com/api/delete/gate-entries/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire("Deleted!", "Gate Entry deleted successfully", "success");

      fetchGateEntries();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Delete failed", "error");
    }
  };

  const filteredGateEntries = gateEntries.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.gate_entry_no?.toLowerCase().includes(text) ||
      item.entry_date?.toLowerCase().includes(text) ||
      item.warehouse?.toLowerCase().includes(text) ||
      item.truck_nos?.join(", ").toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <div className="card shadow-lg border-0">
        <div className="card-header bg-danger text-white">
          <h4 className="mb-0">Delete Gate Entries</h4>
        </div>

        <div className="mb-3">
          <input
            type="text"
            className="form-control border-primary"
            placeholder="🔍 Search Gate Entry / Date / Warehouse / Vehicle..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="card-body table-responsive">
          <table className="table table-hover table-bordered align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Gate Entry No</th>
                <th>Date</th>
                <th>Client</th>
                <th>Vehicle</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {gateEntries.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Records Found
                  </td>
                </tr>
              ) : (
                gateEntries.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    {/* Correct fields */}
                    <td>{item.gate_entry_no}</td>
                    <td>{item.entry_date}</td>
                    <td>{item.client}</td>

                    {/* truck_nos is ARRAY */}
                    <td>{item.truck_nos?.join(", ")}</td>

                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(item.id)}
                      >
                        🗑 Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
